import Hls from 'hls.js';

const root = document.querySelector('[data-course-player]');
if (root) mount(root);

function mount(root) {
  const video = root.querySelector('[data-course-video]');
  if (!video) return;
  const quality = root.querySelector('[data-video-quality]');
  const speed = root.querySelector('[data-video-speed]');
  const loading = root.querySelector('[data-video-loading]');
  const sources = read(root.querySelector('[data-course-sources]')?.textContent);
  let hls = null;
  const storageKey = `course-progress:${root.dataset.partId}`;

  for (const [index, source] of sources.entries()) {
    const option = document.createElement('option'); option.value = String(index); option.textContent = source.label || `کیفیت ${index+1}`; quality.append(option);
  }
  quality.addEventListener('change', () => loadSource(Number(quality.value), video.currentTime));
  speed.addEventListener('change', () => video.playbackRate = Number(speed.value) || 1);
  video.addEventListener('waiting', () => loading.hidden = false);
  video.addEventListener('playing', () => loading.hidden = true);
  video.addEventListener('timeupdate', throttle(() => localStorage.setItem(storageKey, String(video.currentTime)), 1000));
  video.addEventListener('loadedmetadata', () => {
    const saved = Number(localStorage.getItem(storageKey));
    if (Number.isFinite(saved) && saved > 5 && saved < video.duration - 10) video.currentTime = saved;
  }, { once: true });
  document.addEventListener('keydown', e => {
    if (e.target instanceof HTMLInputElement || e.target instanceof HTMLTextAreaElement) return;
    if (e.code === 'Space') { e.preventDefault(); video.paused ? video.play() : video.pause(); }
    if (e.key === 'ArrowLeft') video.currentTime = Math.max(0, video.currentTime - 10);
    if (e.key === 'ArrowRight') video.currentTime = Math.min(video.duration || Infinity, video.currentTime + 10);
  });
  loadSource(0, 0);

  function loadSource(index, resumeAt) {
    const source = sources[index]; if (!source) return;
    loading.hidden = false;
    if (hls) { hls.destroy(); hls = null; }
    if (source.hls && Hls.isSupported()) {
      hls = new Hls({
        enableWorker: true,
        lowLatencyMode: false,
        startLevel: -1,
        testBandwidth: true,
        capLevelToPlayerSize: true,
        abrEwmaDefaultEstimate: 500_000,
        backBufferLength: 30,
        maxBufferLength: 30,
        maxMaxBufferLength: 60
      });
      hls.loadSource(source.url); hls.attachMedia(video);
      hls.on(Hls.Events.MANIFEST_PARSED, () => { if (resumeAt) video.currentTime = resumeAt; loading.hidden = true; });
      hls.on(Hls.Events.ERROR, (_, data) => {
        if (!data.fatal) return;
        if (data.type === Hls.ErrorTypes.NETWORK_ERROR) {
          loading.hidden = false;
          loading.lastChild.textContent = ' اتصال ضعیف است؛ تلاش دوباره برای دریافت ویدیو…';
          hls.startLoad();
          return;
        }
        if (data.type === Hls.ErrorTypes.MEDIA_ERROR) {
          hls.recoverMediaError();
          return;
        }
        loading.textContent = 'پخش این ویدیو ممکن نیست.';
        hls.destroy();
        hls = null;
      });
    } else {
      video.src = source.url; video.load();
      video.addEventListener('loadedmetadata', () => { if (resumeAt) video.currentTime = resumeAt; loading.hidden = true; }, { once: true });
    }
  }
}
function read(value) { try { return JSON.parse(value || '[]'); } catch { return []; } }
function throttle(fn, wait) { let last=0; return (...args) => { const now=Date.now(); if(now-last>=wait){last=now;fn(...args);} }; }
